module.exports = __webpack_public_path__ + "static/media/chat.a7c7ce03.svg";